<template>
  <div>
    <!-- {{messagesList}} -->
    <div class="tree">
      <div class="template">
        <div class="template__item">
          <div class="template__left">
            <div class="template__item_priority"></div>
            <div class="template__item_from"><strong>{{$t('project_tab_messages_first_from')}}</strong></div>
            <div class="template__item_title"><strong>{{$t('project_tab_messages_first_title')}}</strong></div>
            <div class="template__item_status"><strong>{{$t('project_tab_messages_first_status')}}</strong></div>
            <div class="template__item_create"><strong>{{$t('project_tab_messages_first_createDate')}}</strong></div>
            <div class="template__item_view"><strong>{{$t('project_tab_messages_first_viewDate')}}</strong></div>
          </div>
          <div class="template__item_link"></div>
        </div>
        <div class="template__item" :class="{'font-weight': !(list.isViewed)}" v-for="list in messagesList" :key="list.id">
          <div @click="showItem(list.id)" class="template__left">
            <div class="template__item_priority">
              <el-tag type="success" size="mini" v-html="list.priority.name"></el-tag>
            </div>
            <div class="template__item_from" v-html="list.fromCompanyUser.user.fullName"></div>

            <el-tooltip :content="list.subject" placement="top">
              <div class="template__item_title" v-html="reductionStr(list.subject)"></div>
            </el-tooltip>

            <div class="template__item_status" v-html="status(list.actionType)"></div>
            <div class="template__item_create">{{moment(list.createDate * 1000).format("D MMM YY, HH:mm:ss")}}</div>
            <!-- moment(list.createDate * 1000).format("D MMM YY") -->
            <div class="template__item_view"><span v-if="list.viewDate">{{moment(list.viewDate * 1000).format("D MMM YY, HH:mm:ss")}}</span></div>
          </div>
          <div class="template__item_link">
            <!-- <el-button @click="deleteVendor(list.id)" type="danger" icon="el-icon-delete" size="mini" plain></el-button> -->
            <el-button @click="reply(list)" type="warning" size="mini" plain title="Reply">
              <i class="fas fa-reply"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- [ Modal info ] start -->
    <sweet-modal blocking ref="info" class="modal" v-on:close="closeModal">
      <h1 class="modal__title">{{$t('project_tab_messages_first_messageInfo')}}</h1>

      <div class="modal__name">
        <div class="label">{{$t('project_tab_messages_first_from')}}</div> {{itemInfo.fullName}}
      </div>
      <div class="modal__date">
        <div class="label">{{$t('project_tab_messages_first_date')}}</div> {{moment(itemInfo.createDate * 1000).format("D MMM YY, HH:mm:ss")}}
      </div>
      <div class="modal__subject">
        <div class="label">{{$t('project_tab_messages_first_subject')}}</div> {{itemInfo.subject}}
      </div>
      <div class="modal__text" v-html="itemInfo.text"></div>
      <div class="modal__reply">
        <el-button @click="reply(itemInfoList)" type="warning" size="mini" plain :title="$t('project_tab_messages_first_replay')">
          <i class="fas fa-reply"></i>
        </el-button>
      </div>
    </sweet-modal>
    <!-- [ Modal info ] end -->
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  components: {
    SweetModal,

  },
  props: ['type', 'activeProjectId', 'selectedRow'],
  computed: {
    messagesList() {
      return this.$store.state.messagesList
    },
  },
  data() {
    return {
      moment:moment,

      itemId: null,

      itemInfoList: null,
      itemInfo: {
        fullName: '',
        createDate: '',
        subject: '',
        text: '',
      },
      test: null,
    }
  },
  methods: {
    reductionStr(str){
      if (str.length > 25) {
        return str.slice(0, 25) + '...'
      } else {
        return str
      }
    },
    status(id) {
      if (id === 1) {
        return 'For Action'
      } else if (id === 2) {
        return 'For Comment'
      } else {
        return 'For Information Only'
      }
    },
    closeModal() {
      if (this.type == 'task') {
        this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
      } else if (this.type == 'project') {
        this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': this.activeProjectId, 'projectMessageType': '1'})
      } else if (this.type == 'taskBusinessUnit') {
        this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
      } else if (this.type == 'businessUnit') {
        this.$store.dispatch('getMessagesList', {'type': 'businessUnit', 'businessUnitId': this.activeProjectId, 'projectMessageType': '1'})
      } else if (this.type == 'taskEngagement') {
        this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeProjectId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
      } else if (this.type == 'engagement') {
        this.$store.dispatch('getMessagesList', {'type': 'engagement', 'engagementId': this.activeProjectId, 'projectMessageType': '1'})
      }
    },
    reply(list) {
      this.$emit('reply', list)
      if (this.type == 'task') {
        this.$store.dispatch('getMessagesDirectories', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id})
      } else if (this.type == 'project') {
        this.$store.dispatch('getMessagesDirectories', {'type': 'project', 'projectId': this.activeProjectId})
      }else if (this.type == 'taskBusinessUnit') {
        this.$store.dispatch('getMessagesDirectories', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id})
      } else if (this.type == 'businessUnit') {
        this.$store.dispatch('getMessagesDirectories', {'type': 'businessUnit', 'businessUnitId': this.activeProjectId})
      } else if (this.type == 'taskEngagement') {
        this.$store.dispatch('getMessagesDirectories', {'type': 'taskEngagement', 'engagementId': this.activeProjectId, 'engagementTaskId': this.selectedRow.id})
      } else if (this.type == 'engagement') {
        this.$store.dispatch('getMessagesList', {'type': 'engagement', 'engagementId': this.activeProjectId, 'projectMessageType': '1'})
      }
    },
    showItem(id) {
      this.itemId = id

      if (this.type == 'task') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectTaskMessages/info?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}&projectTaskMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/projectTaskMessages/info', response.data.item);
            this.itemInfoList = response.data.item
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/projectTaskMessages/view?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}&projectTaskMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/projectTaskMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });

          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      } else if (this.type == 'project') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectMessages/info?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/projectMessages/info', response.data.item);
            this.itemInfoList = response.data.item
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/projectMessages/view?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/projectMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });

          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      } else if (this.type == 'taskBusinessUnit') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTaskMessages/info?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitTaskId=${this.selectedRow.id}&businessUnitTaskMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/businessUnitTaskMessages/info', response.data.item);
            this.itemInfoList = response.data.item
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnitTaskMessages/view?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitTaskId=${this.selectedRow.id}&businessUnitTaskMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/businessUnitTaskMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });

          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      } else if (this.type == 'businessUnit') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitMessages/info?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitMessageId=${this.itemId}`)
          .then(response => {
            console.log('---/businessUnitMessages/info', response.data.item);
            this.itemInfoList = response.data.item
            this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
            this.itemInfo.createDate = response.data.item.createDate
            this.itemInfo.subject = response.data.item.subject
            this.itemInfo.text = response.data.item.text
            loader.hide()
            this.$refs.info.open();

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnitMessages/view?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitMessageId=${this.itemId}`)
              .then(response => {
                console.log('---/businessUnitMessages/view', response.data);
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      }else if (this.type == 'engagement') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/engagementMessages/info?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementMessageId=${this.itemId}`)
                .then(response => {
                  console.log('---/engagementMessages/info', response.data.item);
                  this.itemInfoList = response.data.item
                  this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
                  this.itemInfo.createDate = response.data.item.createDate
                  this.itemInfo.subject = response.data.item.subject
                  this.itemInfo.text = response.data.item.text
                  loader.hide()
                  this.$refs.info.open();

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                          .post(`/api/v1/engagementMessages/view?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementMessageId=${this.itemId}`)
                          .then(response => {
                            console.log('---/engagementMessages/view', response.data);
                          })
                          .catch(error => {
                            console.log('An error occurred:', error);
                          });

                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      }else if (this.type == 'taskEngagement') {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/engagementTaskMessages/info?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.selectedRow.id}&engagementTaskMessageId=${this.itemId}`)
                .then(response => {
                  console.log('---/engagementTaskMessages/info', response.data.item);
                  this.itemInfoList = response.data.item
                  this.itemInfo.fullName = response.data.item.fromCompanyUser.user.fullName
                  this.itemInfo.createDate = response.data.item.createDate
                  this.itemInfo.subject = response.data.item.subject
                  this.itemInfo.text = response.data.item.text
                  loader.hide()
                  this.$refs.info.open();

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios
                          .post(`/api/v1/engagementTaskMessages/view?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.selectedRow.id}&engagementTaskMessageId=${this.itemId}`)
                          .then(response => {
                            console.log('---/engagementTaskMessages/view', response.data);
                          })
                          .catch(error => {
                            console.log('An error occurred:', error);
                          });

                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      }
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.tree {
  width: 100%;
  overflow-y: auto;
  font-size: 12px;
  overflow: auto;
  .template {
    border-bottom: 1px dashed #d9d9d9;
    &:last-child {
      border-bottom: none;
    }

    .font-weight {
      font-weight: bold;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 40px;
      padding: 10px 0;
      border-bottom: 1px dashed #d9d9d9;
      &:hover {
        background: #f7f7f7;
        cursor: pointer;
        &:first-child {
          background: none;
          cursor: auto;
        }
      }

      &_priority {
        width: 70px;
        padding-left: 3px;
        text-align: center;
        .el-tag {
          width: 70px;
          text-align: center;
        }
      }

      &_from {
        width: 170px;
        text-align: center;
      }

      &_title {
        width: 150px;
        text-align: center;
      }

      &_status {
        width: 160px;
        text-align: center;
      }

      &_create {
        width: 150px;
        text-align: center;
        margin-right: 15px;
      }

      &_view {
        width: 150px;
        text-align: center;
      }

      &_link {
        width: 50px;
        text-align: center;
      }
    }
    &__left {
      display: flex;
      justify-content: space-between;
      width: 90%;
    }
  }
}

// [ Modal ] start
.modal {
  .label {
    display: inline-block;
    width: 100px;
    font-weight: bold;
  }
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
  &__name {
    background: #f7f7f7;
    padding: 5px;
  }
  &__date {
    padding: 5px;
  }
  &__subject {
    background: #f7f7f7;
    margin-bottom: 10px;
    padding: 5px;
  }
  &__text {
    box-sizing: border-box;
    margin-bottom: 10px;
    padding: 5px;
    border: 1px solid #DCDCDC;
    border-radius: 5px;
    min-height: 70px;
    max-height: 300px;
    overflow-y: scroll;
  }
  &__reply {
    display: flex;
    justify-content: flex-end;
  }
}
.button{
  cursor: pointer;
}
// [ Modal ] end
</style>
